import { Link, useParams } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import DeleteModal from '../../../components/deleteModal/DeleteModal';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const EmployeeRole = () => {
  const { branchId, userId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    userId: userId,
    title: '',
    // size: 20,
    // part: 1,
    // total: 0,
    // parts: 0
  });
  const [findRoleFilterModel, setfindRoleFilterModel] = useState({
    branchId: branchId,
    userId: userId,
    title: '',
    // part: 1,
    // total: 0,
    // parts: 0
  });
  const [selectRoleModel, setSelectRoleModel] = useState({
    userId: userId,
    roleId: 0,
    branchId: branchId
  });

  const getGridData = async () => {
    const resp = await apiMethod.getEmployeeRoles(filterModel.userId, filterModel.title);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  const findAllRoles = async () => {
    const resp1 = await apiMethod.findRolesForEmployee(findRoleFilterModel.userId, findRoleFilterModel.title);
    if (methods.showApiErrors(resp1)) {
      findRoleFilterModel.total = resp1.total;
      findRoleFilterModel.parts = methods.calcPageParts(resp1.total, findRoleFilterModel.size);
      setfindRoleFilterModel({ ...findRoleFilterModel })
      setAllRoles(resp1.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      setLoading(false);
    }
    bindData();
  }, [branchId, userId]);


  const showAllRoles = () => {
    findAllRoles();
    setShowFormModal(true);
  };

  const selectUser = async (item) => {
    const updatedModel = { ...selectRoleModel, roleId: item.id };
    setSelectRoleModel(updatedModel);
    await addRoleForUser(updatedModel);
  };

  const addRoleForUser = async (model) => {
    setLoading(true);
    const resp = await apiMethod.addRoleToEmployee(model);
    if (methods.showApiErrors(resp)) {
      await getGridData();
    }
    setShowFormModal(false);
    setLoading(false);
  };

  const selectَItemToDelete = async (item) => {
    setSelectRoleModel({ ...selectRoleModel, roleId: item.roleId });
    setShowDeleteModal(true);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeRoleFromEmployee(selectRoleModel);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const resetFilters = () => {
    filterModel.userId = userId;
    filterModel.title = '';
    // filterModel.size = 20;
    // filterModel.part = 1;
    setFilterModel({ ...filterModel })
  };

  const resetFiltersModal = () => {
    findRoleFilterModel.branchId = branchId;
    findRoleFilterModel.userId = userId;
    findRoleFilterModel.title = '';
    // findRoleFilterModel.size = 20;
    // findRoleFilterModel.part = 1;
    setFilterModel({ ...filterModel })
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const searchItemModal = async () => {
    setLoading(true);
    await findAllRoles();
    setLoading(false);
  };

  const clearSearchModal = async () => {
    setLoading(true);
    resetFiltersModal();
    await findAllRoles();
    setLoading(false);
  };


  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-block'>
              <Link to={`/sale/${branchId}/employee`} className='text-start mb-3 link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/employee`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                مدیریت نقش ها /تخصیص نقش
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>مدیریت نقش ها /تخصیص نقش
                <a href={`/sale/${branchId}/softwareGuide/#section6`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row g-1'>
                  <div className='col-12 col-md-6 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={filterModel.title}
                        onChange={(e) => { setFilterModel({ ...filterModel, title: e.target.value, part: 1 }) }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-2 col-lg-4'></div>
                  <div className='col-12 col-md-4 col-lg-4'>
                    <div className='createButton'>
                      <button
                        onClick={() => { showAllRoles() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>تخصیص نقش</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-md " >
                  <thead className='align-middle'>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center" width="50px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {gridData.map((item, index) => (
                      <tr key={item.roleId}>
                        {/* <th scope="row">{((filterModel.part - 1) * filterModel.size) + index + 1}</th> */}
                        <th scope="row">{index + 1}</th>
                        <td>{item.title}</td>
                        <td>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className='btn btn-sm btn-outline-danger' type='button'>
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const closeModal = () => {
    setShowFormModal(false);
    setShowDeleteModal(false);
  };

  const Modal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showFormModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-lg" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">تخصیص نقش</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className='col-12 col-md-4 col-lg-6'>
                <label htmlFor="funit" className="form-label">عنوان</label>
                <div className="hstack">
                  <input
                    id="searchInput"
                    className="form-control"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: 'rtl', textAlign: 'right' }}
                    value={findRoleFilterModel.title}
                    onChange={(e) => { setfindRoleFilterModel({ ...findRoleFilterModel, title: e.target.value, part: 1 }) }}
                  />
                  <button type='button' className='btn btn-purple me-1'
                    onClick={searchItemModal}
                  >
                    <i className="bi bi-search"></i>
                  </button>
                  <button type='button' className='btn btn-outline-info'
                    onClick={clearSearchModal}
                  >
                    <i className="bi bi-arrow-clockwise"></i>
                  </button>
                </div>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-md align-middle" >
                  <thead className=''>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center" width="50px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className=''>
                    {allRoles.map((item, index) => (
                      <tr key={item.id}>
                        {/* <th scope="row">{((filterModel.part - 1) * filterModel.size) + index + 1}</th> */}
                        <th scope="row">{index + 1}</th>
                        <td>{item.title}</td>
                        <td>
                          <button type="button" className="btn btn-sm btn-purple"
                            onClick={() => selectUser(item)}
                          >
                            افزودن
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn custome-btn btn-link-purple"
                onClick={closeModal}
              >
                انصراف
              </button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal &&
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeModal}
          deleteItem={deleteItem}
          text={'نقش'}
        />
      }
    </>

  );
}

export default EmployeeRole;